import { Loadable } from '../../components/common/loadable/loadable';

export const FileManagerLazyContainer = Loadable<any>({
  loader: () =>
    import(/* webpackChunkName: "file-manager" */ './file-manager').then(
      (module) => module.FileManager,
    ),
});
